<ng-scrollbar #scrollbar class="std-scrollbar flex-1" [appearance]="'compact'" orientation="vertical">
  <div class="flex my-2.5 mx-7 flex-col flex-1">
    <form class="flex flex-col h-full" #generalPage="ngForm" role="form">
      <app-input-upload
        [files]="model?.files"
        label="Drag or click to upload files"
        placeholder="Drag or click to upload files"
        (filesChanged)="filesChanged($event)"
        (removeFile)="removeFile($event)"
        [allowMultipleFiles]="true"
      >
      </app-input-upload>

      <app-floating-input
        required
        [(ngModel)]="model.title"
        name="contract_title"
        label="Contract Title"
        placeholder="Contract Title"
      ></app-floating-input>

      <app-floating-input
        required
        [(ngModel)]="model.owner_name"
        name="owner_name"
        label="Owner Name"
        placeholder="Owner Name"
      ></app-floating-input>

      <div class="flex gap-4">
        <app-input-calendar
          required
          [(date)]="model.date"
          class="w-full"
          name="contract_date"
          placeholder="Contract Date"
          [minStartDate]="(project$ | async)?.start_date"
        ></app-input-calendar>
        <app-dropdown
          required
          [optionLabel]="null"
          [optionValue]="null"
          [required]="true"
          placeholder="Contract Status"
          label="Contract Status"
          id="status"
          name="status"
          [(ngModel)]="model.status"
          [options]="statuses"
          class="w-full"
        >
          <ng-template #selectedContent #optionContent let-option>
            <div class="capitalize text-navy-900 text-medium">{{ option }}</div>
          </ng-template>
        </app-dropdown>
      </div>

      <app-floating-input
        [(ngModel)]="model.purchase_order_number"
        name="purchase_order_number"
        [required]="false"
        label="Purchase Order Number"
        placeholder="Purchase Order Number"
      ></app-floating-input>

      <app-floating-textarea
        class="flex-1"
        name="note"
        [(ngModel)]="model.description"
        [required]="false"
        label="Contract Description"
        placeholder="Contract Description"
      ></app-floating-textarea>
      <!--      <label class="flex gap-1 text-navy-600 text-xs mt-2 ml-1 mb-0.5">-->
      <!--        <span class="font-semibold">Contract Description</span>-->
      <!--        <span class="font-normal">(optional)</span>-->
      <!--      </label>-->
      <!--      <div (click)="textAreaElement.focus()" class="textarea-wrapper cursor-text">-->
      <!--        <textarea-->
      <!--          class="flex"-->
      <!--          #textAreaElement-->
      <!--          cdkTextareaAutosize-->
      <!--          name="note"-->
      <!--          [(ngModel)]="model.description"-->
      <!--        ></textarea>-->
      <!--      </div>-->
    </form>
  </div>
</ng-scrollbar>
<div class="my-6 mx-7 flex justify-end gap-4">
  <app-simple-button (click)="goToNextPage()">Next</app-simple-button>
</div>
